import React, { FC } from 'react';
import { TAppointment } from '@api/appointments/types';

export const locationFormatter: FC<TAppointment> = (appointment) => {
  const currentLocation = appointment.locations;

  return <ul>{currentLocation.name}</ul>;
};
